const AdditionalInfoIcon = ({ additionalInfo, openModal }) => {
    if (!additionalInfo || additionalInfo.uiRenderType !== "QUESTIONS") return null;
  
    return (
      <a
        href="#"
        className="question-icon"
        
        onClick={(e) => {
          e.preventDefault();
          openModal(additionalInfo.title, additionalInfo.content);
        }}
      >
        <i className="fa-solid fa-circle-question"></i>
      </a>
    );
  };
  
  export default AdditionalInfoIcon;